import { twMerge } from "tailwind-merge";

import { Typography } from "~/common/components";
import {
  ALL_HEALTH_HISTORY_IDS_V3,
  HEALTH_HISTORY_IDS_V3,
  PREVIEW_TITLE_CODES,
} from "~/providers/constants/SummariesExpandableIds";
import { SymptomsProgressionOverTime } from "~/providers/utils/types/patientIntakePreviewTypes";
import Expandable from "../common/Expandable";
import { PatientPreviewSymptomProgressionV2 } from "../v2/PatientPreviewSymptomProgressionV2";

interface HealthHistoryV3Props {
  history_of_present_illness: string;
  psychiatric_history: string;
  medical_history: string;
  symptoms_progression_over_time: SymptomsProgressionOverTime[];
  substance_history: string;
  summary: string;
}

export const HealthHistoryV3 = ({
  history_of_present_illness,
  medical_history,
  psychiatric_history,
  symptoms_progression_over_time,
  substance_history,
  summary,
}: HealthHistoryV3Props) => (
  <Expandable.Wrapper
    code={PREVIEW_TITLE_CODES.HEALTH_HISTORY}
    expandableSections={[...ALL_HEALTH_HISTORY_IDS_V3]}
  >
    <Typography className="border-b border-neutral-80 pb-3">
      {summary}
    </Typography>
    <Expandable.Section code={HEALTH_HISTORY_IDS_V3.HISTORY_OF_PRESENT_ILLNESS}>
      {history_of_present_illness}
    </Expandable.Section>

    <Expandable.Section code={HEALTH_HISTORY_IDS_V3.PSYCHIATRIC_HISTORY}>
      {psychiatric_history}
    </Expandable.Section>

    <Expandable.Section code={HEALTH_HISTORY_IDS_V3.MEDICAL_HISTORY}>
      {medical_history}
    </Expandable.Section>
    <Expandable.Section
      code={HEALTH_HISTORY_IDS_V3.SUBSTANCE_HISTORY}
      className={twMerge(!symptoms_progression_over_time && "border-none pb-0")}
    >
      {substance_history}
    </Expandable.Section>

    {symptoms_progression_over_time && (
      <Expandable.Section
        code={HEALTH_HISTORY_IDS_V3.SYMPTOM_PROGRESSION_OVER_TIME}
        className="border-none pb-0"
      >
        <PatientPreviewSymptomProgressionV2
          symptomProgression={symptoms_progression_over_time}
        />
      </Expandable.Section>
    )}
  </Expandable.Wrapper>
);
